import { api, endpoints } from "api/api";

export const coursesStatusApi = {
  SESSIONS_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/sessions-ready`);
    return response.data;
  },
  SESSIONS_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/sessions-unready`);
    return response.data;
  },
  TRANCHES_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/tranches-ready`);
    return response.data;
  },
  TRANCHES_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/tranches-unready`);
    return response.data;
  },
  EXAMS_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/exams-ready`);
    return response.data;
  },
  EXAMS_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/exams-unready`);
    return response.data;
  },
  DOCUMENTS_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/documents-ready`);
    return response.data;
  },
  DOCUMENTS_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/documents-unready`);
    return response.data;
  },
  APPLICATION_FORM_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/application-form-ready`);
    return response.data;
  },
  APPLICATION_FORM_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/application-form-unready`);
    return response.data;
  },
  PUBLIC_DATA_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/public-data-ready`);
    return response.data;
  },
  PUBLIC_DATA_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/public-data-unready`);
    return response.data;
  },
  SCHEDULE_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/schedule-ready`);
    return response.data;
  },
  SCHEDULE_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/schedule-unready`);
    return response.data;
  },
  SCHEDULE_PLACES_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/schedule-places-ready`);
    return response.data;
  },
  SCHEDULE_PLACES_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/schedule-places-unready`);
    return response.data;
  },
  RESOURCES_READY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/resources-ready`);
    return response.data;
  },
  RESOURCES_UNREADY: async (courseId: number) => {
    const response = await api.put(`/admin/course-status/${courseId}/resources-unready`);
    return response.data;
  },
};
